import ICommand from '../../../FrontApplet/Command/ICommand';
import { ITypedCommandEvent } from '../../../FrontApplet/Command/ICommandEvent';
import FrontApplet from '../../../FrontApplet/FrontApplet';
import {
	ManagementSecurityGenerateRandomPinCodeRequest,
	ManagementSecurityGenerateRandomPinCodeResult,
	ManagementSecurityGetPinCodeRequest,
	ManagementSecurityGetPinCodeResult,
	ManagementSecurityRequests,
	ManagementSecuritySetPinCodeRequest,
	ManagementSecuritySetPinCodeResult,
} from './securityCommands';

export function handleManagementSecurityRequests(
	onCommand: (callback: (commandEvent: ITypedCommandEvent<ManagementSecurityRequests>) => Promise<void>) => void,
	dispatch: <TCommand extends ICommand>(command: TCommand) => Promise<void>,
	frontApplet: FrontApplet,
) {
	onCommand(async (commandEvent: ITypedCommandEvent<ManagementSecurityRequests>) => {
		switch (commandEvent.command.type) {
			case ManagementSecurityGetPinCodeRequest:
				await dispatch<ManagementSecurityGetPinCodeResult>({
					type: ManagementSecurityGetPinCodeResult,
					pinCode: await frontApplet.management.security.getPinCode(),
				});
				break;
			case ManagementSecuritySetPinCodeRequest:
				await frontApplet.management.security.setPinCode(commandEvent.command.pinCode);
				await dispatch<ManagementSecuritySetPinCodeResult>({
					type: ManagementSecuritySetPinCodeResult,
					result: {},
				});
				break;
			case ManagementSecurityGenerateRandomPinCodeRequest:
				await frontApplet.management.security.generateRandomPinCode();
				await dispatch<ManagementSecurityGenerateRandomPinCodeResult>({
					type: ManagementSecurityGenerateRandomPinCodeResult,
					result: {},
				});
				break;
			default:
		}
	});
}
